import React, { useState } from 'react';
import './css/services.css';

const FAQItem = ({ question, answer }) => {
  const [isOpen, setIsOpen] = useState(false);

  const toggle = () => {
    setIsOpen(!isOpen);
  };

  return (
    <div className="faq-item">
      <div onClick={toggle} className="faq-question">
        <strong>{question}</strong>
        <span>{isOpen ? '▲' : '▼'}</span>
      </div>
      {isOpen && (
        <div className="faq-answer">
          {answer}
        </div>
      )}
    </div>
  );
};

const FAQList = () => {
  const faqs = [
     {
    question: 'What types of websites do you develop?',
    answer: 'We build corporate websites, eCommerce stores, portfolio sites, landing pages, and custom web applications tailored to your business goals.',
  },
  {
    question: 'Do you use CMS platforms like WordPress or Shopify?',
    answer: 'Yes, we work with popular CMS platforms such as WordPress, Shopify, Webflow, and also offer custom-coded solutions using HTML, PHP, React, and Laravel.',
  },
  {
    question: 'Are your websites mobile-friendly and responsive?',
    answer: 'Absolutely. Every website we develop is optimized for desktop, tablet, and mobile devices for a seamless user experience.',
  },
  {
    question: 'Do you offer website maintenance and support after launch?',
    answer: 'Yes, we offer ongoing support, updates, backups, and security monitoring as part of our website maintenance services.',
  },
  {
    question: 'How long does it take to build a website?',
    answer: 'Timelines vary depending on the scope. A standard business website can take 2–4 weeks, while custom or eCommerce sites may take 4–8 weeks.',
  },
  {
    question: 'Will my website be optimized for SEO?',
    answer: 'Yes, all websites are built with technical SEO best practices, including fast load speeds, mobile optimization, schema markup, and clean URL structures.',
  },
    // Add more questions and answers as needed
  ];

  return (
    <div>
      {faqs.map((faq, index) => (
        <FAQItem key={index} question={faq.question} answer={faq.answer} />
      ))}
    </div>
  );
};

const App = () => {
  return (
    <div style={{ padding: '5%' }}>
      <div className="seo-main-faq">
    <div className="seo-main-heading">
      <h1>FAQ’S</h1>
    </div>
      <div className="seo-main-para">
        <p></p>
      </div>
      </div>
      <FAQList />
    </div>
  );
};

export default App;
